import gql from 'graphql-tag';

export const GET_CODE_LIST = gql`
  query(
    $code_key: String!
    $default_display: Int!
  ) {
    GetCodeList(
      code_key: $code_key
      default_display: $default_display
    ) {
      CodeList{
        code_key
        code
        code_name
        code_key_name
      }
    }
  }
`;

export const GET_CODE_KEY_LIST = gql`
  query(
    $codeKeyList: [String]
  ) {
    GetCodeListByKeys(
      CodeKeyList: $codeKeyList
    ) {
      CodeKeyRecList{
        codeKey
        codeRec {
          code_key
          code
          code_name
          code_key_name
          reserve1
          reserve2
          reserve3
          reserve4
          reserve5
          valid_flag
        }
      }
    }
  }
`;

